import type React from 'react';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from '@doda/pc/src/redux/store';

const OR_INFORMATION_MAIL_COMMIT = `12`;

/**
 * 企業情報リンク計測関連処理
 *
 * sp実装参照(sp/src/logics/analytics/clickEventModule/companyPageLink.ts#measureCompanyPageLinkButtonClick)
 * @param event
 * @param option
 */
export function measureClickCompanyPageLink(
  event: React.MouseEvent<HTMLAnchorElement>,
  option: {
    jid: string;
    hasArticleContent: boolean;
  }
): AnalyticsAppThunk<RootState> {
  return (_, getState) => {
    event.preventDefault();
    const { message_id, scoutlist_id, osscfl, wlstid } =
      appQueryParamsSelector(getState());
    const { jid, hasArticleContent } = option;
    const url = event.currentTarget.href;
    const hasMessageAndScout = message_id && scoutlist_id;
    const hasOsscflAndWlstid =
      osscfl && osscfl === OR_INFORMATION_MAIL_COMMIT && wlstid;

    let companyPageUrl = `${url}?jid=${jid}`;
    if (hasMessageAndScout) {
      companyPageUrl += `&message_id=${message_id}&scoutlist_id=${scoutlist_id}`;
    } else if (hasOsscflAndWlstid) {
      companyPageUrl += `&osscfl=${osscfl}&wlstid=${wlstid}`;
    }
    if ((hasMessageAndScout || hasOsscflAndWlstid) && hasArticleContent) {
      companyPageUrl += `&hasPremiumOffer=true`;
    }

    tl('KGM_genkou_Link_Click_header', {
      linkTrackVars: 'prop32',
      prop32: `${jid}`,
    });

    window.open(companyPageUrl, '_blank');
  };
}
